import React from 'react';
import moment from 'moment';
import store from '../../store';
import admin from '../../api/admin';
import confirmAction from '../../utils/confirm';
import {edit_training_path} from 'routes'

class Training extends React.Component {
  deleteEvent = () => {
    const {id} = this.props.training;
    confirmAction(() => {
      admin.deleteTraining(id).then(() => location.reload());
    });
  }

  render() {
    const { training, t_controls } = this.props;
    const user = store.getState().current_user;
    const locale = user.locale;
    const controls = this.props.t_controls.controls;

    return (
      <div className="list-post-modern game-result">
        <article>
          <div className="post-modern">
            <div className="tag">
              <div className="badge badge-blue">
                {training.type}
              </div>
            </div>
            <figure className="training">
              <img src={training.team_logo} />
            </figure>
            <div className="post-modern-main">
              <div className="post-modern-info">
                <h3 className="game-info-title">{training.name}</h3>
                <div className="game-info-middle">
                  <time className="time-big">
                    <span className="heading-3">
                      {moment(training.started_at).format('DD')}
                      </span> 
                      {moment(training.started_at).format('MMM YYYY')}
                  </time>
                  <time className="time-big">
                    <span className="heading-5">{moment(`${training.started_at}`).format('HH:mm')}</span>
                  </time>
                </div>
                <p> {training.description} </p>
              </div>
            </div>
          </div>
          { user?.admin &&
            <div className="game-buttons">
              <a className="button button-sm button-primary" href={`${edit_training_path(training.id, { locale: locale })}`}>{`${controls.edit}`}</a>
              <button className="button button-sm button-primary" onClick={this.deleteEvent}>{`${controls.delete}`}</button>
            </div>
          }
        </article>
      </div> 
    )
  }
}

export default Training
